import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setActivePage, resetActivePage } from 'redux/common/actions';
import { fetchLinksList, fetchMobileAppsLinksList } from 'redux/links/actions';
import { fetchSocialNetworksList, fetchSocialLinksList } from 'redux/social/actions';
import { fetchCatalogProductsList, fetchCatalogDescription } from 'redux/catalog/actions';
import { fetchCurrencies } from 'redux/common/actions';
import { fetchHighlightsDetailsList } from 'redux/highlights/actions';
import { fetchImageSlidersList } from 'redux/image-sliders/actions';
import { fetchPageBlockItemsList, fetchCountries } from 'redux/users/actions';
import { fetchCommerceLinksList } from 'redux/commerce/actions';
import { fetchCryptoServicesList, fetchCryptoLinksList } from 'redux/crypto-links/actions';
import { fetchLocationLinksList } from 'redux/location-links/actions';
import { fetchMenuLinksList } from 'redux/menu-links/actions';

import { Redirect } from 'react-router-dom';

import CommonLoader from 'components/common/CommonLoader';
import CommonActionNotification from 'components/common/CommonActionNotification';
import DashboardHeader from 'components/dashboard/common/DashboardHeader';
import DashboardNavBar from 'components/dashboard/common//DashboardNavBar';
import DashboardPreviewContent from 'components/dashboard/preview-content/DashboardPreviewContent';

import { getCookie } from 'utils/cookies';

import './DashboardLayout.css';



const DashboardLayout = props => {
  const {
    me,
    meError,
    children,
    emptyPage,
    activePage,
    setActivePage,
    resetActivePage,
    fetchLinksList,
    fetchMobileAppsLinksList,
    fetchSocialNetworksList,
    fetchSocialLinksList,
    fetchCatalogProductsList,
    fetchCatalogDescription,
    fetchCurrencies,
    fetchHighlightsDetailsList,
    fetchImageSlidersList,
    fetchPageBlockItemsList,
    fetchCommerceLinksList,
    fetchCryptoServicesList,
    fetchCryptoLinksList,
    fetchLocationLinksList,
    fetchMenuLinksList,
    fetchCountries,
    countries,
    currencies,
    linksList,
    socialLinksList,
    socialNetworksList,
    mobileAppsLinksList,
    catalogProductsList,
    catalogDescription,
    highlightsDetailsList,
    imageSlidersList,
    pageBlockItemsList,
    commerceLinksList,
    cryptoServicesList,
    cryptoLinksList,
    locationLinksList,
    menuLinksList,
  } = props;

  const [hidePreview, setHidePreview] = useState(false);

  useEffect(() => {
    setActivePage(activePage);

    if (!countries) { fetchCountries(); }
    if (!currencies) { fetchCurrencies(); }
    if (!linksList) { fetchLinksList(); }
    if (!socialLinksList) { fetchSocialLinksList(); }
    if (!socialNetworksList) { fetchSocialNetworksList(); }
    if (!mobileAppsLinksList) { fetchMobileAppsLinksList(); }
    if (!catalogProductsList) { fetchCatalogProductsList(); }
    if (!catalogDescription) { fetchCatalogDescription(); }
    if (!highlightsDetailsList) { fetchHighlightsDetailsList(); }
    if (!imageSlidersList) { fetchImageSlidersList(); }
    if (!pageBlockItemsList) { fetchPageBlockItemsList(); }
    if (!cryptoServicesList) { fetchCryptoServicesList(); }
    if (!commerceLinksList) { fetchCommerceLinksList(); }
    if (!cryptoLinksList) { fetchCryptoLinksList(); }
    if (!locationLinksList) { fetchLocationLinksList(); }
    if (!menuLinksList) { fetchMenuLinksList(); }

    return () => {
      resetActivePage();
    };
  }, []);

  if ((!me && !getCookie('accessToken')) || meError) {
    return <Redirect to="/login" />;
  }

  if (!me) return <CommonLoader active />;

  return (
    <div className={`dashboard-layout__component${hidePreview ?
      ' hide-preview' : ''}`}>
      <CommonActionNotification />

      <div className="main-wrapper">
        {/* Content Wrapper */}
        <div className="content-container">

          {/* Preview Controller */}
          <div className={`preview-controller${hidePreview ? ' hide' : ''}`}
            onClick={() => {setHidePreview(!hidePreview)}}
            role="button"
            tabIndex={-1}
          />

          <div className="dashboard-header">
            <DashboardHeader />
          </div>

          {!emptyPage &&
            <div className="dashboard-nav-bar">
              <DashboardNavBar activePage={activePage} />
            </div>
          }

          {/* Content Area */}
          <div className="content-area">
            {children}
          </div>
        </div>

        {/* Preview Wrapper */}
        <div className={`dashboard-preview${hidePreview ? ' hide' : ''}`}>
          <DashboardPreviewContent />
        </div>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  setActivePage: PropTypes.func.isRequired,
  resetActivePage: PropTypes.func.isRequired,
  fetchLinksList: PropTypes.func.isRequired,
  fetchMobileAppsLinksList: PropTypes.func.isRequired,
  fetchSocialNetworksList: PropTypes.func.isRequired,
  fetchSocialLinksList: PropTypes.func.isRequired,
  fetchCatalogProductsList: PropTypes.func.isRequired,
  fetchCatalogDescription: PropTypes.func.isRequired,
  fetchCurrencies: PropTypes.func.isRequired,
  fetchHighlightsDetailsList: PropTypes.func.isRequired,
  fetchImageSlidersList: PropTypes.func.isRequired,
  fetchPageBlockItemsList: PropTypes.func.isRequired,
  fetchCommerceLinksList: PropTypes.func.isRequired,
  fetchCountries: PropTypes.func.isRequired,
  fetchCryptoServicesList: PropTypes.func.isRequired,
  fetchCryptoLinksList: PropTypes.func.isRequired,
  fetchLocationLinksList: PropTypes.func.isRequired,
  fetchMenuLinksList: PropTypes.func.isRequired,
  me: PropTypes.object,
  meError: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  activePage: PropTypes.string,
  emptyPage: PropTypes.bool,
  countries: PropTypes.arrayOf(PropTypes.shape),
  currencies: PropTypes.arrayOf(PropTypes.shape),
  linksList: PropTypes.arrayOf(PropTypes.shape),
  socialLinksList: PropTypes.arrayOf(PropTypes.shape),
  socialNetworksList: PropTypes.arrayOf(PropTypes.shape),
  mobileAppsLinksList: PropTypes.arrayOf(PropTypes.shape),
  catalogProductsList: PropTypes.arrayOf(PropTypes.shape),
  catalogDescription: PropTypes.object,
  highlightsDetailsList: PropTypes.arrayOf(PropTypes.shape),
  imageSlidersList: PropTypes.arrayOf(PropTypes.shape),
  pageBlockItemsList: PropTypes.arrayOf(PropTypes.shape),
  commerceLinksList: PropTypes.arrayOf(PropTypes.shape),
  cryptoServicesList: PropTypes.arrayOf(PropTypes.shape),
  cryptoLinksList: PropTypes.arrayOf(PropTypes.shape),
  locationLinksList: PropTypes.arrayOf(PropTypes.shape),
  menuLinksList: PropTypes.arrayOf(PropTypes.shape),
};

DashboardLayout.defaultProps = {
  me: null,
  meError: null,
  activePage: null,
  emptyPage: null,
  countries: null,
  currencies: null,
  linksList: null,
  socialLinksList: null,
  socialNetworksList: null,
  mobileAppsLinksList: null,
  catalogProductsList: null,
  catalogDescription: null,
  highlightsDetailsList: null,
  imageSlidersList: null,
  pageBlockItemsList: null,
  commerceLinksList: null,
  cryptoServicesList: null,
  cryptoLinksList: null,
  locationLinksList: null,
  menuLinksList: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    meError: state.usersReducer.meError,
    countries: state.usersReducer.countries,
    currencies: state.commonReducer.currencies,
    linksList: state.linksReducer.linksList,
    socialLinksList: state.socialReducer.socialLinksList,
    socialNetworksList: state.socialReducer.socialNetworksList,
    mobileAppsLinksList: state.linksReducer.mobileAppsLinksList,
    catalogProductsList: state.catalogReducer.catalogProductsList,
    catalogDescription: state.catalogReducer.catalogDescription,
    highlightsDetailsList: state.highlightsReducer.highlightsDetailsList,
    imageSlidersList: state.imageSlidersReducer.imageSlidersList,
    pageBlockItemsList: state.usersReducer.pageBlockItemsList,
    commerceLinksList: state.commerceReducer.commerceLinksList,
    cryptoServicesList: state.cryptoLinksReducer.cryptoServicesList,
    cryptoLinksList: state.cryptoLinksReducer.cryptoLinksList,
    locationLinksList: state.locationLinksReducer.cryptoLinksList,
    menuLinksList: state.menuLinksReducer.menuLinksList,
  }
);

export default connect(
  mapStateToProps,
  {
    setActivePage,
    resetActivePage,
    fetchLinksList,
    fetchMobileAppsLinksList,
    fetchSocialNetworksList,
    fetchSocialLinksList,
    fetchCatalogProductsList,
    fetchCatalogDescription,
    fetchCurrencies,
    fetchHighlightsDetailsList,
    fetchImageSlidersList,
    fetchPageBlockItemsList,
    fetchCommerceLinksList,
    fetchCountries,
    fetchCryptoServicesList,
    fetchCryptoLinksList,
    fetchLocationLinksList,
    fetchMenuLinksList,
  },
)(DashboardLayout);
